export default __webpack_public_path__ + "static/media/Mahabalipuram05.0783a97c.png";